module.exports = __webpack_public_path__ + "static/media/upload.da2af11b.svg";